import React, { useEffect, useState } from "react"
import useAuth from "../../context/userContext"
import axios from "axios"
import api, { BASE_URL, fetcher } from "../../utils/api"
import Spinner from "../../components/Spinner"
import useSWR from "swr"
import OTPModal from "../../components/modals/OTPModal"
import SMSSenderModal from "../../components/modals/SMSSenderModal"
import DashboardHeader from "../../components/DashboardHeader"
import StatCard from "../../components/Cards/StatCard"
import DashboardOverviewFilter from "../../components/DashboardOverviewFilter"
import ServiceOrderChart from "../../components/Carts/ServiceOrderChart"
import OverviewFilter from "../../components/OverviewFilter"
import RecentOrdersList from "../../components/RecentOrdersList"
import { isAccountOwnerEligibleForSenderIdPrompt } from "../../utils/smsSenderId"


const Dashboard = () => {
  const [analyticData, setAnalyticData] = useState()
  const [loading, setLoading] = useState(true)
  const [isFirstTime, setIsFirstTime] = useState(false)
  const token = localStorage.getItem("token")
  const { showSmsModal, setShowSmsModal, user: authUser } = useAuth()
  const [selectedFilter, setSelectedFilter] = useState("30 days")
  const [stats, setStats] = useState(null)
  const [loadingState, setLoadingState] = useState(true)
  const [localUser, setLocalUser] = useState(null)

  const user = authUser || localUser
  const verificationRequired =
    window.localStorage.getItem("verification_required") === "true"
  const needsFirstTimeOtp =
    user?.user_type !== "activity_user" &&
    verificationRequired &&
    (Boolean(user?.is_firsttime) || isFirstTime)

  const { data: harvestRequest } = useSWR(
    `harvest-requests/`,
    fetcher
  )


  const getDashboardAnalytics = () => {
    setLoading(true)
    var config = {
      method: "get",
      url: `${BASE_URL}miller/getDashboardAnalytics/`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: "",
    }

    axios(config)
      .then(function (response) {
        setAnalyticData(response.data)
        setLoading(false)
      })
      .catch(function (error) {

        setLoading(false)
      })
  }

  const getStats = async () => {
    setLoadingState(true)
    try {
      const response = await api.get('farmers/statistics/')

      if (response.status === 200 && response.data) {
        setStats(response.data)
      }
    } catch (error) {
      console.error('Error fetching stats:', error)
    } finally {
      setLoadingState(false)
    }
  }

  useEffect(() => {

    const storedUser = JSON.parse(window.localStorage.getItem("user"))
    setIsFirstTime(Boolean(storedUser?.is_firsttime))
    setLocalUser(storedUser)
  }, [])

  useEffect(() => {
    getDashboardAnalytics()
    getStats()
  }, [])



  return (
    <div className="w-full lg:px-10 px-2 h-full py-6 lg:py-10 space-y-6">
      <DashboardHeader label="Dashboard" />

      {/* First-time account OTP: resend-otp + verify-otp */}
      {needsFirstTimeOtp && (
        <OTPModal isOpen={true} setIsOpen={() => { }} dismissible={false} />
      )}
      {isAccountOwnerEligibleForSenderIdPrompt(user) && showSmsModal && (
        <SMSSenderModal isOpen={showSmsModal} setIsOpen={setShowSmsModal} />
      )}

      {/* Dashboard filter */}
      {/* <DashboardOverviewFilter
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
      /> */}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        <StatCard title={"Total Farmers"} count={stats?.total_farmers || 0} />
        <StatCard title={"Total Farms"} count={stats?.total_farms || 0} />
        <StatCard title={"Total Requests"} count={harvestRequest?.length || 0} />
      </div>

      <OverviewFilter
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
      />

      {/* <CommodityPrices /> */}

      {/* chats */}
      {loading ? (
        <div className="w-full h-full flex justify-center items-center">
          <Spinner />
        </div>
      ) : (
        <>
            {/* charts */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              <div className="col-span-3">
                <ServiceOrderChart data={{
                  dataset: {
                    label: analyticData?.orderChartData?.labels,
                    data: analyticData?.orderChartData?.datasets,
                  }
                }} />
              </div>
            </div>
            {/* orders */}
            <RecentOrdersList orders={analyticData?.recentOrders || []} />
        </>
      )}
    </div>
  )
}

export default Dashboard
